import { firestoreAction } from 'vuexfire'
import {db} from "@/plugins/db";


export default {
    namespace: true,
    state:{
        histories: []
    },
    actions:{
        bindHistories: firestoreAction(({ bindFirestoreRef }) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('histories', db.collection('HistoryClass').orderBy('createdAt', 'desc'))
        })
    }
}